/**
 * @file Retour utilisateur partage : puits de toasts (enregistre par Toasts), envoi de commande avec toast d'erreur `error.<code>`, confirmation.
 */
import type { Command, ToastKind } from '@core/index';
import type { Result } from '@shared/types';
import type { TranslationKey } from '@i18n/index';
import { uiAppRef } from '../UiApp';
import type { ScreenId, UiContext } from '../UiContext';

export interface ToastSink {
  show(text: string, kind: ToastKind): void;
}

/** Renseigne par le composant Toasts quand il est monte. */
export const toastSink: { current: ToastSink | null } = { current: null };

/** Indices transmis d'un composant a un ecran qui s'ouvre (ex. onglet initial de Missions). */
export const uiHints: { missionsTab: 'missions' | 'pass' | 'daily' | null; hubShopTab: 'fx' | 'fireworks' | null } = { missionsTab: null, hubShopTab: null };

export const notify = (text: string, kind: ToastKind = 'info'): void => {
  toastSink.current?.show(text, kind);
};

/** Envoie une commande ; un refus du core devient un toast `error.<code>`. */
export const send = (ctx: UiContext, cmd: Command): Result<unknown> => {
  const r = ctx.sim.dispatch(cmd);
  if (!r.ok) notify(ctx.i18n.tDyn(`error.${r.error}`), 'warning');
  return r;
};

/** Boite de confirmation via l'UiApp (resout `true` si l'UI n'est pas disponible). */
export const confirmAsk = (textKey: TranslationKey): Promise<boolean> => uiAppRef.current?.confirm(textKey) ?? Promise.resolve(true);

export const openScreen = (id: ScreenId): void => {
  uiAppRef.current?.openScreen(id);
};

export const closeScreen = (): void => {
  uiAppRef.current?.closeScreen();
};

/** Ecran plein actuellement ouvert (null = jeu). */
export const currentScreen = (): string | null => uiAppRef.current?.currentScreen ?? null;
